import React from 'react';
import classnames from 'classnames';

// Styles
import './LoadingShimmer.scss';

type Props = {
  shape: 'circle' | 'rectangle' | 'square';
  height: string;
  width: string;
  margin?: string;
  shimmerStart?: string;
};

const LoadingShimmer = ({ shape, height, width, margin, shimmerStart }: Props) => {
  const baseClassName = 'LoadingShimmer';

  const classes = classnames(baseClassName, `${baseClassName}--${shape}`, `${baseClassName}--animate`);

  // Set the CSS variable for shimmer start if provided
  const style = {
    width,
    height,
    margin,
    ...(shimmerStart ? ({ '--shimmer-start': shimmerStart } as React.CSSProperties) : {}),
  };

  return <div className={classes} style={style} />;
};

export default LoadingShimmer;
